// getLivestreamEarning.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';
import { EMPTY_OBJECT, EMPTY_ARRAY } from '../resource/defaults.js';

import { LIVESTREAM_DIAMONDS_EARNING_CATEGORIES } from '../RemoteConfigKeys.js';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

/**
 * Select livestream earning by stream id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @return {number} The total livestream diamonds earning.
 */
const getLivestreamEarning = createCachedSelector(
  (state, streamId) => getLiveStreamData(state, [streamId, 'diamondCount']),
  state => getRemoteConfigData(state, LIVESTREAM_DIAMONDS_EARNING_CATEGORIES),
  (diamondCount = EMPTY_OBJECT, earningCategories = EMPTY_ARRAY) => {
    const total = earningCategories.reduce(
      (accumulated, key) => accumulated + (diamondCount[key] || 0),
      0
    );
    return total;
  }
)((state, streamId) => `${streamId}`);

export default getLivestreamEarning;
